import React from "react";
import { Redirect } from "react-router-dom";

const CompanyDetails = () => {
  return <Redirect to="/companies" />;
};

export default CompanyDetails;
